import { LANGUAGE_LOCALES_CODE } from "../constants"

const langCodeInterceptor = (client) => {
    client.interceptors.request.use((config) => {	
        const newConfig = {
            ...config,
            ...(config.params?.lang && {
                params: {
                    ...config.params,
                    lang: LANGUAGE_LOCALES_CODE[config.params.lang]
                }
            })
        }

        return newConfig
    })
}

export default langCodeInterceptor